export const PRODUCTS_MODULE_VIEWS = {
    PRODUCT_DETAILS: "PRODUCT_DETAILS",
};